<template>
  <div
    class="notification"
    :class="`notification--${type}`"
    :role="role"
    :aria-live="ariaLive"
    aria-atomic="true"
  >
    <slot />
  </div>
</template>

<script setup>
import { computed } from 'vue'

const { type } = defineProps({
  type: { type: String, default: 'info' }
})

const error_types = ['warning', 'error']

const isErrorType = computed(() => error_types.includes(type))
const role = computed(() => isErrorType.value ? 'alert': 'status')
const ariaLive = computed(() => isErrorType.value ? 'assertive': 'polite')
</script>

<style scoped lang="scss">
.notification {
  padding: 12px;
  margin-bottom: 24px;
  border-top-right-radius: $radius__cards;
  border-bottom-right-radius: $radius__cards;
  background: tint($color--tertiary, 50%, 90%);
  border-left: 3px solid $color--tertiary;
  word-break: break-word;

  &--warning {
    background: tint($color--warning, 50%, 90%);
    border-color: $color--warning;
  }

  &--error {
    background: tint($color--danger, 50%, 90%);
    border-color: $color--danger;
  }

  &--info {
    border-color: #10298E;
    background: rgba(#10298E, 0.1);
  }
}
</style>